export const ROLES = [
  'SUPER_ADMIN',
  'ADMIN_ECOLE',
  'AGENT_SCOLARITE',
  'AGENT_FINANCE',
  'ENSEIGNANT',
  'ETUDIANT',
  'CANDIDAT',
] as const;
export type Role = (typeof ROLES)[number];

/** Roles that exist inside a tenant (SUPER_ADMIN lives on the platform host only). */
export const TENANT_ROLES = ROLES.filter((r): r is Exclude<Role, 'SUPER_ADMIN'> => r !== 'SUPER_ADMIN');
export type TenantRole = (typeof TENANT_ROLES)[number];

export const MODULES = [
  'dashboard',
  'admissions',
  'students',
  'curriculum',
  'timetable',
  'attendance',
  'grades',
  'deliberations',
  'internships',
  'documents',
  'finance',
  'announcements',
  'settings',
  'audit',
] as const;
export type Module = (typeof MODULES)[number];

/**
 * Design's permission levels: Aucun / Le sien / Lecture / Édition.
 * `own` grants read and write on the user's own records only (a teacher's grade sheets,
 * a student's own file); the route decides what "own" means.
 */
export const PERMISSION_LEVELS = ['none', 'own', 'read', 'edit'] as const;
export type PermissionLevel = (typeof PERMISSION_LEVELS)[number];
